// Smartsetup Application Configuration
//======================================================================================//
// Application Basic Info
export const appName = "Project setup";

//======================================================================================//
// Application API URLs UAT
// export const appBaseUrl = "https://uatpreventtb237.imonitorplus.com/";
// export const appApiUrl = "https://uatpreventtb237.imonitorplus.com/service/api/";

// Application API URLs LIVE
// export const appBaseUrl = "https://tptdemo.imonitorplus.com/";
// export const appApiUrl = "https://tptdemo.imonitorplus.com/service/api/";

// Application API URLs Dev

export const appBaseName = "cdicv21";
export const appAdminModuleName = "cdicdashboardv21";
export const appBaseUrl = "https://stagingcameroon.imonitorplus.com/";
export const appApiUrl = "https://stagingcameroon.imonitorplus.com/service/api/";

// Application API URLs Local
// export const appBaseUrl = "http://localhost:8080/";
// export const appApiUrl = "http://localhost:8080/dhis/api/";
//======================================================================================//

